import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
import classNames from 'classnames';
import React, { Component } from 'react';
var css = {
  "componentWrapper": "rui-bL30O",
  "error": "rui-z9cZt",
  "inputContainer": "rui-B9s5L",
  "label": "rui-gBleD",
  "text": "rui-k3jef",
  "optionsWrapper": "rui-u0Ywm",
  "input": "rui-pCBUo",
  "iconContainer": "rui-Crm1K",
  "list": "rui-IfzAL",
  "listWrapper": "rui-D8HM7",
  "listElement": "rui-ZxeHW",
  "active": "rui-Bp4vy",
  "lastFixedItem": "rui-ZDoC4",
  "hideElement": "rui-loetL"
};
import Icon from '../Icon/Icon';
import { upArrowKeyCode, downArrowKeyCode, enterKeyCode } from '../constants/keyboardKeys';
var delayTime = 250;
var defaultHighlightedValue = null;
var charSearchLimit = 2;
var SearchableOption = /*#__PURE__*/function (_Component) {
  _inherits(SearchableOption, _Component);
  var _super = _createSuper(SearchableOption);
  function SearchableOption(props) {
    var _this;
    _classCallCheck(this, SearchableOption);
    _this = _super.call(this, props);
    _this.listRefs = {};
    _this.timeoutIds = [];
    _this.avoidScrolling = false;
    _this.inputRef = null;
    _this.onInputChange = function (event) {
      var val = event.target.value;
      _this.setState({
        inputValue: val,
        showCheckedIcon: false
      });
      _this.filterOptions(val);
    };
    _this.filterOptions = function () {
      var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : _this.state.inputValue;
      if (value && value.length > charSearchLimit) {
        var filterValue = value && value.toUpperCase();
        var options = _this.props.options;
        var lastValue = options[options.length - 1].name;
        var hiddenIndexes = {};
        var showOtherOption = true;
        options.forEach(function (item, index) {
          var itemName = item.name.toUpperCase();
          var wordsArr = itemName.split(' ');
          var existsInWords = _this.isWordsIncludeFilterVal(wordsArr, filterValue);
          if (existsInWords) {
            showOtherOption = false;
          } else {
            hiddenIndexes[index] = true;
          }
        });
        if (showOtherOption && lastValue.toUpperCase() === 'OTHER') {
          hiddenIndexes = Object.assign(Object.assign({}, hiddenIndexes), _defineProperty({}, options.length - 1, false));
        }
        _this.setState({
          hiddenIndexes: hiddenIndexes,
          showOtherOption: showOtherOption
        });
      } else {
        _this.setState({
          hiddenIndexes: {},
          showOtherOption: false
        });
      }
    };
    _this.isWordsIncludeFilterVal = function (wordsArr, filterValue) {
      for (var i = 0; i < wordsArr.length; i++) {
        if (wordsArr[i].trim().startsWith(filterValue)) {
          return true;
        }
      }
      return false;
    };
    _this.toggleList = function () {
      var cb = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : function () {};
      _this.setState(function (prevState) {
        return {
          isListOpen: !prevState.isListOpen
        };
      }, function () {
        return cb();
      });
    };
    _this.selectItem = function (value, index) {
      return function () {
        if (!value && index) {
          var objAtIndex = _this.props.options[index];
          value = objAtIndex.name;
        }
        _this.toggleList(_this.onItemSelection(value));
        _this.props.onSelect(value);
      };
    };
    _this.onItemSelection = function (value) {
      return function () {
        _this.setState({
          inputValue: value,
          highlightedIndex: defaultHighlightedValue,
          showCheckedIcon: !!value
        });
      };
    };
    _this.handleKeyDown = function (e) {
      var highlightedIndex = _this.state.highlightedIndex;
      if (e.keyCode === upArrowKeyCode && highlightedIndex && highlightedIndex > 0) {
        _this.setState(function (prevState) {
          var prevIndex = prevState.highlightedIndex;
          return {
            highlightedIndex: prevIndex === defaultHighlightedValue ? 0 : prevIndex - 1
          };
        });
      } else if (e.keyCode === downArrowKeyCode && highlightedIndex && highlightedIndex < _this.props.options.length - 1) {
        _this.setState(function (prevState) {
          var prevIndex = prevState.highlightedIndex;
          return {
            highlightedIndex: prevIndex === defaultHighlightedValue ? 0 : prevIndex + 1
          };
        });
      } else if (e.keyCode === enterKeyCode) {
        _this.selectItem('', highlightedIndex)();
      }
    };
    _this.onClearSelection = function () {
      _this.setState({
        inputValue: '',
        highlightedIndex: defaultHighlightedValue,
        showCheckedIcon: false
      });
      if (_this.state.isListOpen) {
        _this.toggleList();
      }
    };
    _this.callAfterDelay = function (fn, time) {
      var id = setTimeout(function () {
        fn();
      }, time);
      _this.timeoutIds.push(id);
    };
    _this.inputBlurEvent = function () {
      _this.callAfterDelay(function () {
        if (_this.state.isListOpen) {
          _this.toggleList();
        }
      }, delayTime);
      _this.setState({
        highlightedIndex: defaultHighlightedValue
      });
      if (!_this.state.showCheckedIcon) {
        _this.setState({
          inputValue: ''
        });
      }
    };
    _this.onListMouseMoveHandler = function (index) {
      return function () {
        _this.avoidScrolling = true;
        _this.callAfterDelay(function () {
          return _this.avoidScrolling = false;
        }, delayTime);
        _this.setState({
          highlightedIndex: index
        });
      };
    };
    _this.openListWithFilteredVal = function () {
      _this.toggleList(_this.filterOptions);
    };
    _this.onDropdownIconClick = function () {
      var _a;
      if (_this.state.isListOpen) {
        _this.toggleList();
      } else {
        (_a = _this.inputRef) === null || _a === void 0 ? void 0 : _a.focus();
      }
    };
    _this.renderInputLabel = function () {
      var label = _this.props.label;
      return label ? /*#__PURE__*/React.createElement("label", {
        className: css.label
      }, label) : null;
    };
    _this.renderInput = function () {
      var placeholder = _this.props.placeholder;
      var isListOpen = _this.state.isListOpen;
      return /*#__PURE__*/React.createElement("div", {
        className: css.inputContainer
      }, /*#__PURE__*/React.createElement("input", {
        type: "text",
        "data-aut-id": "searchableInput",
        onChange: _this.onInputChange,
        placeholder: placeholder,
        className: css.input,
        value: _this.state.inputValue,
        autoComplete: 'off',
        onFocus: _this.openListWithFilteredVal,
        onKeyDown: _this.handleKeyDown,
        onBlur: _this.inputBlurEvent,
        ref: function ref(input) {
          return _this.inputRef = input;
        },
        key: "searchable-options"
      }), _this.renderInputIcons(), /*#__PURE__*/React.createElement("button", {
        className: css.iconContainer,
        onClick: _this.onDropdownIconClick
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: isListOpen ? 'arrowUp' : 'arrowDown',
        size: 16
      })));
    };
    _this.renderInputIcons = function () {
      var _this$state = _this.state,
        isListOpen = _this$state.isListOpen,
        showCheckedIcon = _this$state.showCheckedIcon,
        inputValue = _this$state.inputValue;
      return /*#__PURE__*/React.createElement(React.Fragment, null, showCheckedIcon && !isListOpen && /*#__PURE__*/React.createElement("div", {
        className: css.iconContainer
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: 'okHaired',
        size: 16,
        color: "accentDark"
      })), inputValue && isListOpen && /*#__PURE__*/React.createElement("button", {
        onClick: _this.onClearSelection,
        className: css.iconContainer
      }, /*#__PURE__*/React.createElement(Icon, {
        icon: 'crossRounded',
        size: 16,
        color: "blackDisabled"
      })));
    };
    _this.renderOptions = function () {
      var _this$state2 = _this.state,
        highlightedIndex = _this$state2.highlightedIndex,
        hiddenIndexes = _this$state2.hiddenIndexes;
      return /*#__PURE__*/React.createElement("div", {
        className: css.listWrapper
      }, /*#__PURE__*/React.createElement("div", {
        className: css.list
      }, _this.props.options.map(function (item, index) {
        return /*#__PURE__*/React.createElement("div", {
          key: index,
          className: classNames(css.listElement, highlightedIndex === index ? css.active : null, hiddenIndexes[index] ? css.hideElement : null),
          ref: function ref(instance) {
            return _this.listRefs[index] = instance;
          },
          onClick: _this.selectItem(item.name, index),
          onMouseMove: _this.onListMouseMoveHandler(index),
          onKeyPress: _this.selectItem(item.name, index),
          tabIndex: 0,
          role: "button"
        }, item.name);
      })));
    };
    _this.renderErrorText = function () {
      var errorText = _this.props.errorText;
      return /*#__PURE__*/React.createElement("div", {
        className: css.text
      }, errorText);
    };
    _this.state = {
      isListOpen: false,
      inputValue: '',
      highlightedIndex: defaultHighlightedValue,
      showCheckedIcon: false,
      hiddenIndexes: {},
      showOtherOption: false
    };
    return _this;
  }
  _createClass(SearchableOption, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevState) {
      if (!this.avoidScrolling && this.state.isListOpen && prevState.highlightedIndex !== this.state.highlightedIndex) {
        this.scrollHighlightedItemIntoView();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.clearTimeouts();
    }
  }, {
    key: "scrollHighlightedItemIntoView",
    value: function scrollHighlightedItemIntoView() {
      var highlightedIndex = this.state.highlightedIndex;
      if (highlightedIndex) {
        var node = this.listRefs[highlightedIndex];
        node.scrollIntoView({
          behavior: 'smooth',
          block: 'nearest',
          inline: 'nearest'
        });
      }
    }
  }, {
    key: "clearTimeouts",
    value: function clearTimeouts() {
      this.timeoutIds.forEach(function (id) {
        clearTimeout(id);
      });
      this.timeoutIds = [];
    }
  }, {
    key: "render",
    value: function render() {
      var errorText = this.props.errorText;
      return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
        className: classNames(css.componentWrapper, errorText && this.state.showOtherOption ? css.error : null)
      }, this.renderInputLabel(), /*#__PURE__*/React.createElement("div", {
        className: css.optionsWrapper
      }, this.renderInput(), this.state.isListOpen && this.renderOptions()), this.state.showOtherOption && this.renderErrorText()));
    }
  }]);
  return SearchableOption;
}(Component);
SearchableOption.defaultProps = {
  errorText: '',
  label: '',
  placeholder: ''
};
export default SearchableOption;